import React, { FC } from 'react';
import classNames from 'classnames';

import { Amount } from 'app/design-system/components/Amount';
import { Trans, useTranslation } from 'app/lang';
import { replacingHyphenOnDash } from 'app/lib/replaceDashSymbol';

import { PledgeStakeSingleDAO } from '../../../../../types/backend/paymentOptions';
import Name from '../../../../EntryComponents/Name';
import PriceDiff from '../../../../PriceDiff';

import dictionary from './SingleEntry.dictionary.json';

import entryStyles from '../../../../EntryComponents/EntryComponents.module.scss';
import styles from './SingleEntry.module.scss';

// ---

type SingleEntryProps = {
  data: PledgeStakeSingleDAO;
  isSelected: boolean;
  isDisabled: boolean;
  betId?: number;
};

const SingleEntry: FC<SingleEntryProps> = ({ data, isSelected, isDisabled, betId }) => {
  const { t } = useTranslation();
  const _className = classNames(styles.singleEntry, {
    [styles.selectedEntry]: isSelected || isDisabled,
  });

  const replacedMatchName = replacingHyphenOnDash(data.matchName);

  const dataGaAttributes = {
    ['data-ga-event']: 'cart-bidSourceEventSelect',
    ['data-ga-event-content']: betId,
    ['data-ga-event-value']: data.price,
  };

  return (
    <div className={_className}
         title={isDisabled ? t(dictionary.title) : ''}
         {...dataGaAttributes}
         data-test="singleEntry-container">
      <div className={styles.entryName}
           data-test="singleEntry-entryName">
        <Name value={data.betName}
              data-test="singleEntry-name"
              className={entryStyles.entryName} />
        {isSelected && (
          <div className={styles.selected}
               data-test="singleEntry-selected">
            {t(dictionary.selectedText)}
          </div>
        )}
      </div>

      <div className={styles.stakeNameContainer}
           data-test="singleEntry-stakeNameContainer">
        <Name value={data.stakeName}
              data-test="singleEntry-stakeName"
              className={entryStyles.stakeName} />

        <PriceDiff data-test="singleEntry-priceDiff"
                   prev={data.price} />
      </div>

      <Name value={replacedMatchName}
            data-test="singleEntry-matchName"
            className={entryStyles.matchName} />

      <div className={classNames(entryStyles.datetime, styles.maxWinning)}
           data-test="singleEntry-maxWinning">
        <Trans data={dictionary.maxWinningText}
               components={{
                 amount: (
                   <Amount value={data.maxWinning}
                           className={styles.amount}
                           currency={data.currency} />
                 ),
               }} />
      </div>
    </div>
  );
};

export default SingleEntry;
